import logging from '../logging';

export default {
  track: () => {
    /*
    if (logging.isProdEnv()) {
      logging.warn('Analytics disabled.');
    }
    */
  },
  identify: () => {
    /*
    if (logging.isProdEnv()) {
      logging.warn('Analytics disabled.');
    }
    */
  },
};
